import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import LoadingCard from 'hb-react/frontoffice/apps/LiveFeed/components/TopPosts/LoadingCard';

const LoadingItem = () => (
  <StyledBox dataTestId="builder-loading-item">
    <LoadingCard />
  </StyledBox>
);

export default LoadingItem;

const StyledBox = styled(Box).attrs(() => ({
  display: 'block',
  height: '100%',
  py: 1,
}))``;
